import { apiService } from '../services/service-factory';

export default {
  data: function() {
    return {
      apiService: undefined
    };
  },
  created: function() {
    this.apiService = apiService;
  }
};
